export enum Role {
    OWNER = 'owner',
    ADMIN = 'admin',
    OPERATOR = 'operator',
    QUOTATIONS_OPERATOR = 'quotations-operator',
    SHIPMENTS_OPERATOR = 'shipments-operator',
}
